export var OperationTransactionStatusType;
(function (OperationTransactionStatusType) {
    OperationTransactionStatusType["Confirmed"] = "Confirmed";
    OperationTransactionStatusType["Canceled"] = "Canceled";
})(OperationTransactionStatusType || (OperationTransactionStatusType = {}));
